module.exports = __webpack_public_path__ + "img/Warlock-gnome-m-70.2d896604.gif";